import Button from '../Button';
import { withDirtyFormProxyButton } from './withDirtyFormProxyButton';

const DirtyFormProxyButton = withDirtyFormProxyButton(Button);

export default DirtyFormProxyButton;
